// Polyfills
import 'core-js/modules/es.array.find-index';

// Global variables / plugins
import './globals';
import 'jquery-ui';
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/dialog';
import 'jquery-ajax-unobtrusive';
import 'jquery-dateformat/dist/jquery-dateformat';
import 'bootstrap';
import 'bootstrap-toggle';
import 'bootstrap-show-password/bootstrap-show-password';
import 'autonumeric';
import 'jquery-validation-unobtrusive';
import 'multiselect-two-sides/dist/js/multiselect';
import '../Plugins/gisw-password-requirements-checker';
import 'gisw/Helpers/ClientValidation';
// Below imports use import/export when loaded
import 'datatables.net';
import 'datatables.net-jqui';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-plugins/api/fnFindCellRowIndexes';
import 'datatables.net-plugins/sorting/datetime-moment';
import 'datatables.net-rowgroup';
import 'select2';
